<template>
  <div>
    <h1 class="text-2xl mb-6">Arbitrage Daily Report Config</h1>
    <DailyReportConfigTable
      ref="DailyReportConfigTable"
    ></DailyReportConfigTable>
    <v-row justify="center" class="mt-6 mb-6">
      <v-btn class="primary" @click="dialog = true"
        >Ajouter une nouvelle config</v-btn
      >
    </v-row>
    <v-dialog v-model="dialog">
      <ConfigCreation
        @close-dialog="dialog = false"
        @saved="handleConfigSaved"
      ></ConfigCreation>
    </v-dialog>
    <v-snackbar v-model="showSuccessMessage" color="success" timeout="3000" top>
      Config crée avec succès
    </v-snackbar>
  </div>
</template>
<script>
import DailyReportConfigTable from "@/components/acquisition/daily-report/tables/DailyReportConfigTable.vue";
import ConfigCreation from "@/components/acquisition/daily-report/cards/ConfigCreation.vue";
export default {
  name: "ArbitrageDailyReportConfig",
  components: { DailyReportConfigTable, ConfigCreation },
  data() {
    return {
      dialog: false,
      showSuccessMessage: false,
    };
  },
  methods: {
    handleConfigSaved() {
      this.dialog = false;
      this.showSuccessMessage = true;
      this.$refs.DailyReportConfigTable.getData();
    },
  },
};
</script>
<style></style>
